import apiClient from "../../services/apiClient";

// 문법 출제기. 운영진만 열리고, 실제 차단은 서버가 한다.
//
// **출제 지침과 프롬프트는 이 파일에도, 화면에도 없다.** 서버가 소분류 번호만 받아서
// 무엇을 어떻게 만들지 정한다. 프런트엔드 번들은 누구나 내려받을 수 있어서, 여기에 두면
// 공개하는 것과 같다.

// 레벨 → 대분류 → 소분류 트리와 소분류별 보유 문항 수.
export async function fetchGrammarSkillTreeAPI() {
  const response = await apiClient.get("/api/v1/echo/admin/grammar/skills", {
    withAuth: true,
  });
  return response.data;
}

// 소분류 하나에 문항을 만든다. 결과는 검수 대기 초안으로 쌓인다.
//
// `apiKey` 는 검증 기간에만 화면에서 받아 넘긴다. 서버가 그 요청 한 번에만 쓰고
// 저장하지 않는다. 브라우저에도 남기지 않으므로 새로고침하면 다시 입력해야 한다.
export async function generateGrammarItemAPI({ subId, count, model, apiKey }) {
  const response = await apiClient.post(
    "/api/v1/echo/admin/grammar/generate",
    { sub_id: subId, count, model, api_key: apiKey },
    { withAuth: true }
  );
  return response.data;
}

// 검수 대기 초안 목록.
export async function fetchGrammarDraftListAPI({ status = "draft", subId = "" } = {}) {
  const query = new URLSearchParams({ status });
  if (subId) {
    query.set("sub_id", subId);
  }
  const response = await apiClient.get(
    `/api/v1/echo/admin/grammar/drafts?${query.toString()}`,
    { withAuth: true }
  );
  return response.data;
}

// 초안 승인·반려. 승인해야 진단·복습에 나간다.
//
// **검수를 통과하지 못한 초안은 서버가 승인을 막는다.** 막힌 것은 `blocked` 로 돌아온다.
// 사람이 눈으로 보고 그래도 내보내겠다고 할 때만 `force` 를 준다.
export async function decideGrammarDraftAPI(action, draftIdList, { force = false } = {}) {
  const response = await apiClient.post(
    "/api/v1/echo/admin/grammar/drafts",
    { action, draft_id_list: draftIdList, force },
    { withAuth: true }
  );
  return response.data;
}

// 고른 초안을 다시 검수한다. 정답을 가리고 모델에게 다시 풀려서 대조한다.
export async function verifyGrammarDraftAPI(draftIdList, apiKey) {
  const response = await apiClient.post(
    "/api/v1/echo/admin/grammar/drafts",
    { action: "verify", draft_id_list: draftIdList, api_key: apiKey },
    { withAuth: true }
  );
  return response.data;
}

// 검수함에서 문항을 직접 고친다. 고치면 검수 결과가 미검수로 돌아가므로 다시 검수해야 한다.
export async function updateGrammarDraftAPI(draftId, changes) {
  const response = await apiClient.patch(
    "/api/v1/echo/admin/grammar/drafts",
    { draft_id: draftId, changes },
    { withAuth: true }
  );
  return response.data;
}
